import React from 'react';
import PropTypes from 'prop-types';

import Progress from '../progress/progress';

import './numerical-pagination.scss';

const NumericalPagination = (props) => {
	const {
		paginationData,
		progressDelay,
		progressSpeed,
	} = props;

	const progressBars = [];

	for (let i = 1; i <= paginationData.total; i += 1) {
		progressBars.push(
			<Progress
				key={i}
				active={paginationData.current === i}
				delay={progressDelay}
				speed={progressSpeed}
			/>,
		);
	}

	return (
		<div className="slider-numerical-pager__inner">
			<span className="slider-numerical-pager__indicator">{paginationData.current.toString().padStart(2, '0')}</span>
			{progressBars}
			<span className="slider-numerical-pager__indicator faded">{paginationData.total.toString().padStart(2, '0')}</span>
		</div>
	);
};

NumericalPagination.defaultProps = {
	paginationData: {},
	progressDelay: 0,
	progressSpeed: 3000,
};

NumericalPagination.propTypes = {
	paginationData: PropTypes.shape({
		current: PropTypes.number,
		total: PropTypes.number,
	}),
	progressDelay: PropTypes.number,
	progressSpeed: PropTypes.number,
};

export default NumericalPagination;
